export default "__VITE_ASSET__7K$mHoLd__"